import { useInfiniteQuery } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { buildPaginationParams } from "../utils/pagination"
import { useAuthToken } from "./useAuthToken"

export type ResortRow = {
  uid: string
  name: string
  liftCount: number
  runCount: number
  totalRunLengthMeters?: number
  isGroup: boolean
  orphanedScraper?: boolean
}

type ResortsResponse = {
  resorts: ResortRow[]
  nextCursor?: string
}

type UseResortsParams = {
  filter?: string
  sort: string
  dir: "asc" | "desc"
  hasLiftOpeningIntegration?: boolean
  hasSnowReportIntegration?: boolean
  orphanedScrapers?: boolean
}

export function useResorts({ filter, sort, dir, hasLiftOpeningIntegration, hasSnowReportIntegration, orphanedScrapers }: UseResortsParams) {
  const token = useAuthToken()
  
  return useInfiniteQuery({
    queryKey: ["resorts", { filter, sort, dir, hasLiftOpeningIntegration, hasSnowReportIntegration, orphanedScrapers }],
    queryFn: async ({ pageParam }) => {
      const params = buildPaginationParams({ 
        cursor: pageParam, 
        filter, 
        sort, 
        dir 
      })
      const queryParams = new URLSearchParams(params)
      if (hasLiftOpeningIntegration) {
        queryParams.set("hasLiftOpeningIntegration", "true")
      }
      if (hasSnowReportIntegration) {
        queryParams.set("hasSnowReportIntegration", "true")
      }
      if (orphanedScrapers) {
        queryParams.set("orphanedScrapers", "true")
      }
      const data = await apiFetch<ResortsResponse>(`/admin/resorts?${queryParams.toString()}`, {
        token,
        method: "GET",
      })
      return data
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    initialPageParam: undefined as string | undefined,
  })
}
